// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TeacherAuth_wrapper__4Xz6F"};